import { createSigninOnReturnHandler } from "@react/foundation/auth";

import { isUserToken } from "@platform/core";

import { API } from "../../../bootstrap/api.ts";
import { logger } from "../../../bootstrap/logger.ts";
import { router } from "../../../bootstrap/router.ts";
import { authStore } from "../state/auth.ts";
import { authSessionStore } from "../state/auth-session.ts";
import { signinOnReturnStore } from "../state/signin-on-return.ts";

export const signinOnReturn = createSigninOnReturnHandler({
  authSessionStore,
  authStore,
  getAuthToken: async ({ code }) =>
    API.auth.getAuthToken({
      code,
      // oxlint-disable-next-line custom/no-dangerous-operations
      dangerouslyRequestAdminRole: true,
    }),
  isValidToken: isUserToken,
  logger,
  signinOnReturnStore,
  webCallbackUrl: router.getUrl("AuthCallback"),
});
